export default "__VITE_ASSET__nIIFNscg__"